import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { SubmitButton } from 'components/common/buttons/SubmitButton';

const AddNoteModal = ({ isOpen, onClose, onSubmit, loader, editData }) => {
    const { register, handleSubmit, reset, setValue } = useForm();

    useEffect(() => {
        if (editData) {
            setValue('note', editData.note);
        } else {
            reset({ note: '' });
        }
    }, [editData, isOpen, reset, setValue]);

    const handleFormSubmit = (data) => {
        onSubmit(data);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
            <ModalHeader toggle={onClose} className='header_modal align-items-center'>
                <h5 className="modal-title_u">{editData ? 'Edit Note' : 'Add Note'}</h5>
            </ModalHeader>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <ModalBody className='modal_form_body'>
                    <div className="row-primary">
                        <h2>Note</h2>
                        <textarea
                            className="form-control"
                            rows="4"
                            style={{ fontSize: '14px' }}
                            placeholder="Enter your note here..."
                            {...register('note', { required: true })}
                        ></textarea>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <SubmitButton btnText={editData ? "Update Note" : "Add Note"} loader={loader} />
                    <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default AddNoteModal;
